import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SellerSettings } from '@api/src/models/AgentApi/Contract/seller-settings';
import { UserState } from '@core/user/user.state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'currencyFormat',
    standalone: true,
})
export class CurrencyFormatPipe implements PipeTransform {
    private sanitizer: DomSanitizer = inject(DomSanitizer);
    private userState: UserState = inject(UserState);

    public transform(value: string | number): Observable<SafeHtml> {
        return this.userState.sellerSettings$.pipe(
            map((sellerSettings: SellerSettings) => {
                let format: string;

                switch (sellerSettings.currency) {
                    case 'USD':
                        format = '$0.00';
                        break;
                    case 'RUB':
                        format = '₽0.00';
                        break;
                    case 'EUR':
                        format = '€0.00';
                        break;
                    default:
                        format = '€0.00';
                        break;
                }

                const match: RegExpExecArray = RegExp(/([\\.\d]+)/).exec(format);
                if (!match) {
                    throw new Error(`Invalid format: ${format}`);
                }
                const numberFormat: string = match[1];
                const decPos: number = numberFormat.search(/\./);
                const decNum: number = decPos > 0 ? numberFormat.substring(decPos + 1).length : 0;
                const options: {
                    maximumFractionDigits: number;
                    minimumFractionDigits: number;
                    useGrouping: boolean;
                } = {
                    minimumFractionDigits: decNum,
                    maximumFractionDigits: decNum,
                    useGrouping: false,
                };

                const num: string = Intl.NumberFormat('en', options).format(value as number);

                return this.sanitizer.bypassSecurityTrustHtml(format.replace(numberFormat, num));
            }),
        );
    }
}
